import { Component, OnInit, ViewChild, ElementRef, NgZone } from '@angular/core';
import { AuthenticationService } from '@services/security';
import { LoginUserRequestModel } from "@shared/LoginUserRequestModel";
import { Router, ActivatedRoute } from "@angular/router"
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { AppConsts } from "@shared/app-consts";
import { LoaderService } from '@modules/loader';
import { EnumAuthenticateState } from '@shared/security/enum-auth-state';
import { RecaptchaService } from '@services/security/recaptcha-service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  isLoading: boolean = false;
  returnUrl: string;
  loginForm: FormGroup;
  loginError: any = false;
  emailPattern: string = AppConsts.EMAIL_PATTERN;
  submitted: boolean = false;
  rememberMe: any = false;
  web_Url: string = AppConsts.API_URL;
  public storeUser: LoginUserRequestModel = new LoginUserRequestModel("", "", false);
  submitWithCaptcha = RecaptchaService.submitWithCaptcha;
  
  constructor(private route: ActivatedRoute, private service: AuthenticationService,
    private router: Router,
    public formBuilder: FormBuilder,
    private loaderService: LoaderService, private zone: NgZone) {
  }

  ngOnInit() {
    this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';
    this.service.isLoginPage.next(true);
    this.loaderService.hideLoader();
    let email = "";
    const rememberMe = localStorage.getItem(AppConsts.REMEMBER_ME);
    if (rememberMe && rememberMe != null && rememberMe != "")
      this.rememberMe = JSON.parse(rememberMe);

    if (this.rememberMe) {
      email = localStorage.getItem(AppConsts.USER_MAIL);
    }
    this.storeUser = new LoginUserRequestModel(email, "", this.rememberMe);
    this.buildLoginForm();
  }

  get f() { return this.loginForm.controls; }

  ngAfterViewInit() {
  }

  buildLoginForm() {
    this.loginForm = this.formBuilder.group({
      Email: [
        "",
        Validators.compose([
          Validators.maxLength(100),
          Validators.pattern(this.emailPattern),
          Validators.required
        ])
      ],
      Password: [
        "",
        Validators.compose([
          Validators.minLength(8),
          Validators.required
        ])
      ],
      RememberMe: [""]
    });

    this.loginForm.controls['Email'].valueChanges.subscribe(value => {
      this.storeUser.Email = value;
    });

    this.loginForm.controls['Password'].valueChanges.subscribe(value => {
      this.storeUser.Password = value;
    });

    this.loginForm.controls['RememberMe'].valueChanges.subscribe(value => {
      this.rememberMe = value;
    });
    this.loginForm.controls['Email'].setValue(this.storeUser.Email);
    this.loginForm.controls['RememberMe'].setValue(this.storeUser.RememberMe);
  }

  handleValidSubmit = (event) =>{
    event.preventDefault();
    this.submitWithCaptcha(this.login.bind(this),event,"submit");
  }

  login($event: MouseEvent, token : string) {
    ($event.target as HTMLButtonElement).disabled = true;
    this.submitted = true;
    this.loginError = false;
    if (this.loginForm.invalid) {
      ($event.target as HTMLButtonElement).disabled = false;
      return;
    }
    this.isLoading = true;
    let user = new LoginUserRequestModel(this.storeUser.Email, btoa(this.storeUser.Password), this.storeUser.RememberMe);
    user.RecaptchaToken = token;
    user.IsTwoFactorRememberClient = true;
    this.service.login(user).subscribe((response: any) => {
      if (response && response != null && !response.IsError) {
        if (response.CnxEtatCompte == EnumAuthenticateState.ChgMDP) {
          const link = response.LinkResetPassword;
          this.zone.runOutsideAngular(() => {
            window.location.href = link;
          });
        }
        if (response.IsTwoFactorRequired) {
          sessionStorage.setItem(AppConsts.REMEMBER_ME, this.rememberMe);
          sessionStorage.setItem(AppConsts.DecisielCurrentEmail, this.storeUser.Email);
          this.router.navigate(['login/send-code']);
        }
        else
          this.signIn(response);
      }
      else {
        ($event.target as HTMLButtonElement).disabled = false;
        this.loginError = true;
      }
      this.isLoading = false;
    }, error => {
      ($event.target as HTMLButtonElement).disabled = false;
      this.loginError = true;
      this.isLoading = false;
    });
    return false;
  }

  signIn(response: any) {
    this.service.isLoginPage.next(false);
    this.service.signIn(response, this.storeUser.Email, this.rememberMe);
    this.router.navigate(['']);
    if (this.returnUrl != 'undefined' && this.returnUrl != null && this.returnUrl.length > 0 && this.returnUrl != '/') {
      this.zone.runOutsideAngular(() => {
        window.location.href = this.returnUrl;
      });
    }
  }


  redirectToLostPassword() {
    this.router.navigate['/lostpassword'];
  }
}
